
import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';

const DashboardStatsList = ({
    title,
    items,
    renderItem, // Function to render card content: (item, index) => ReactNode
    loading = false,
    emptyMessage,
    gridCols = "grid-cols-1" // Allow customization of grid columns
}) => {
    const { t } = useTranslation();

    return (
        <div className="h-full flex flex-col">
            {/* Header */}
            <div className="mb-4 flex items-center justify-between">
                <h3 className="text-lg font-bold text-gray-900">{title}</h3>
            </div>

            {/* Content */}
            <div className="flex-1">
                {loading ? (
                    <div className="flex items-center justify-center h-48 bg-white rounded-2xl border border-gray-200 shadow-sm">
                        <Loader2 className="h-8 w-8 animate-spin text-primary-500" />
                    </div>
                ) : items && items.length > 0 ? (
                    <div className={`grid ${gridCols} gap-3`}>
                        {items.map((item, index) => (
                            <div
                                key={index}
                                className="bg-white p-3 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow duration-200"
                            >
                                {renderItem(item, index)}
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="flex flex-col items-center justify-center h-48 bg-white rounded-2xl border border-gray-200 shadow-sm text-gray-400">
                        <div className="bg-gray-50 rounded-full p-4 mb-3">
                            <i className="far fa-inbox text-2xl"></i>
                        </div>
                        <p className="text-sm font-medium">{emptyMessage || t('common.no-data-available')}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DashboardStatsList;
